import React from 'react';
import './RecapGroupingValidationModal.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

/**
 * RecapGroupingValidationModal Component
 *
 * Warns the user when they attempt to group recaps with mismatched
 * properties (product, currency, unit), listing the specific reason per
 * recap. A mismatch is a WARNING, not a block (Jonas feedback 19.08):
 * "Group Anyway" continues the grouping via onConfirm, Cancel abandons it.
 */
const RecapGroupingValidationModal = ({
  isOpen,
  onClose,
  onConfirm,
  errors = []
}) => {
  if (!isOpen) return null;

  return (
    <div className="recap-validation-modal-overlay" onClick={onClose}>
      <div className="recap-validation-modal" onClick={(e) => e.stopPropagation()}>
        <div className="recap-validation-modal-header">
          <div className="recap-validation-header-content">
            <FontAwesomeIcon icon={faExclamationTriangle} className="recap-validation-icon" />
            <h2>Recap Mismatch Warning</h2>
          </div>
          <button className="recap-validation-modal-close" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <div className="recap-validation-modal-content">
          <p className="recap-validation-description">
            The recaps below differ from the first selected recap in product,
            currency, or unit. You can still group them — review the
            mismatches and confirm.
          </p>

          <div className="recap-validation-error-list">
            {errors.map((error, index) => (
              <div key={index} className="recap-validation-error-item">
                <div className="recap-validation-error-header">
                  <strong>{error.recap.transaction_number}</strong>
                  <span className="recap-validation-error-badge">{error.reason}</span>
                </div>
                <div className="recap-validation-error-details">
                  {error.details}
                </div>
              </div>
            ))}
          </div>

          <div className="recap-validation-modal-footer">
            <button className="recap-validation-cancel-button" onClick={onClose}>
              Cancel
            </button>
            <button className="recap-validation-ok-button" onClick={onConfirm}>
              Group Anyway
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecapGroupingValidationModal;
